import styled from "styled-components";

import ModalFullPage from "@/components/molecules/Modal/ModalFullPage/ModalFullPage";

export const StyledModalMyBrokerSelectorMobile = styled(ModalFullPage)`
    overflow-y: scroll;
    .MyBrokerSelectorMobile {
        padding-inline-start: 0;
        list-style-type: none;
        .broker-name {
            list-style-type: none;
            margin-top: 16px;
            font-size: var(--size-16);
            font-weight: bold;
            line-height: 24px;
            color: var(--color-secondary);
        }
        li {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
    }
`;
